import { useApi } from './api';

export const useTeamsStats = (season) => useApi(`statistics/teams/${season}`);
